"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var _popper = _interopRequireDefault(require("popper.js"));

var _reactDeviceDetect = require("react-device-detect");

var _popover_props = require("./popover_props");

var _style = _interopRequireDefault(require("./style"));

require("../../css/shared/popover.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PopoverJsPositioned =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PopoverJsPositioned, _React$Component);

  function PopoverJsPositioned(props) {
    var _this;

    _classCallCheck(this, PopoverJsPositioned);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PopoverJsPositioned).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "applyReactStyle", function (data) {
      var _this$state = _this.state,
          arrowStyle = _this$state.arrowStyle,
          contentStyle = _this$state.contentStyle,
          placement = _this$state.placement;
      var diffArrowStyle = !(0, _lodash.default)(arrowStyle, data.arrowStyles);
      var diffContentStyle = !(0, _lodash.default)(contentStyle, data.styles);
      var diffPlacement = placement !== data.placement;

      if (diffArrowStyle || diffContentStyle || diffPlacement) {
        _this.setState({
          arrowStyle: data.arrowStyles,
          contentStyle: data.styles,
          placement: data.placement
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "render", function () {
      var _this$props = _this.props,
          arrow = _this$props.arrow,
          children = _this$props.children,
          className = _this$props.className,
          content = _this$props.content,
          contentClassName = _this$props.contentClassName,
          contentVisible = _this$props.contentVisible,
          interactionHandlers = _this$props.interactionHandlers,
          targetClassName = _this$props.targetClassName,
          targetRole = _this$props.targetRole,
          targetTabIndex = _this$props.targetTabIndex;
      var _this$state2 = _this.state,
          arrowStyle = _this$state2.arrowStyle,
          contentStyle = _this$state2.contentStyle,
          placement = _this$state2.placement;
      var classes = (0, _classnames.default)(_defineProperty({
        'vn-popover': true
      }, className, className != null));
      var targetClasses = (0, _classnames.default)(_defineProperty({
        'vn-popover__target': true,
        'vn-popover__target--visible': contentVisible
      }, targetClassName, targetClassName != null));
      var positionFromPlacement = PopoverJsPositioned.mapToPosition(placement);
      var arrowClasses = (0, _classnames.default)(_defineProperty({
        'vn-popover__arrow': true,
        'vn-popover__arrow--visible': contentVisible
      }, "vn-popover__arrow--".concat(positionFromPlacement), positionFromPlacement));
      var contentClasses = (0, _classnames.default)(_defineProperty({
        'vn-popover__content': true,
        'vn-popover__content--visible': contentVisible
      }, contentClassName, contentClassName != null));
      return _react.default.createElement("div", {
        className: classes,
        ref: function ref(node) {
          _this.popoverNode = node;
        },
        style: {
          position: 'static'
        }
      }, _react.default.createElement("a", _extends({
        className: targetClasses
      }, interactionHandlers, {
        role: targetRole,
        tabIndex: targetTabIndex
      }), children), _react.default.createElement("div", {
        className: contentClasses,
        ref: function ref(node) {
          _this.contentNode = node;
        },
        style: contentStyle
      }, arrow && _react.default.createElement("div", {
        className: arrowClasses,
        ref: function ref(node) {
          _this.arrowNode = node;
        },
        style: arrowStyle
      }), content));
    });

    _this.state = {
      arrowStyle: {},
      contentStyle: {},
      placement: undefined
    };
    _this.popoverNode = null;
    _this.contentNode = null;
    _this.arrowNode = null;
    _this.popper = null;
    return _this;
  }

  _createClass(PopoverJsPositioned, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var options = {
        modifiers: {
          applyStyle: {
            enabled: false
          },
          applyReactStyle: {
            enabled: true,
            fn: this.applyReactStyle,
            order: 900
          },
          arrow: {
            enabled: this.arrowNode !== null,
            element: this.arrowNode
          },
          flip: {
            enabled: true
          },
          hide: {
            enabled: true
          },
          offset: {
            offset: "0px, ".concat(_style.default.SPACE.SM, "px")
          },
          preventOverflow: {
            enabled: true,
            padding: 0
          }
        },
        placement: PopoverJsPositioned.mapToPlacement(this.props)
      };

      if (_reactDeviceDetect.isIE || _reactDeviceDetect.isEdge) {
        var computeStyle = {
          gpuAcceleration: false
        };
        options.modifiers.computeStyle = computeStyle;
      }

      this.popper = new _popper.default(this.popoverNode, this.contentNode, options);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.popper) this.popper.destroy();
    }
  }]);

  return PopoverJsPositioned;
}(_react.default.Component);

_defineProperty(PopoverJsPositioned, "mapToPlacement", function (_ref) {
  var alignment = _ref.alignment,
      placement = _ref.placement,
      position = _ref.position;

  if (placement === 'auto') {
    return placement;
  }

  var manualPlacement;

  if (position === 'up') {
    manualPlacement = 'top';
  } else if (position === 'down') {
    manualPlacement = 'bottom';
  } else {
    manualPlacement = position;
  }

  if (alignment === 'top' || alignment === 'left') {
    manualPlacement += '-start';
  } else if (alignment === 'bottom' || alignment === 'right') {
    manualPlacement += '-end';
  }

  return manualPlacement;
});

_defineProperty(PopoverJsPositioned, "mapToPosition", function (placement) {
  if (placement) {
    var position = placement.split('-')[0];

    if (position === 'top') {
      return 'up';
    }

    if (position === 'bottom') {
      return 'down';
    }

    return position;
  }

  return undefined;
});

PopoverJsPositioned.propTypes = _popover_props.propTypes;
PopoverJsPositioned.defaultProps = _popover_props.defaultProps;
PopoverJsPositioned.displayName = 'PopoverJsPositioned';
var _default = PopoverJsPositioned;
exports.default = _default;